import { render } from "./ClaimVehicle.vue?vue&type=template&id=2f7630a5&scoped=true"
import script from "./ClaimVehicle.vue?vue&type=script&lang=js"
export * from "./ClaimVehicle.vue?vue&type=script&lang=js"

import "./ClaimVehicle.vue?vue&type=style&index=0&id=2f7630a5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7630a5"]])

export default __exports__